module.exports = __webpack_public_path__ + "static/media/3DR.70620d9d.png";